import { create } from 'zustand';

/**
 * Search Store
 * Manages search-related state including tail number filters
 */
export const useSearchStore = create((set) => ({
  // Tail number search filters
  searchTailNumbers: [],
  
  /**
   * Set tail numbers to filter by
   * @param {array} tailNumbers - Array containing tail number search data
   */
  setSearchTailNumbers: (tailNumbers) => set({ searchTailNumbers: tailNumbers }),
  
  /**
   * Clear tail number filters
   */
  clearSearchTailNumbers: () => set({ searchTailNumbers: [] }),
}));
